import React from 'react';
import styles from './Security.module.css';

const Security = () => {
  const securityFeatures = [
    {
      icon: '🔒',
      title: 'Bank-Grade Encryption',
      description: 'AES-256 encryption for all data at rest and in transit'
    },
    {
      icon: '🔐',
      title: 'Multi-Factor Authentication',
      description: '2FA required for all user accounts'
    },
    {
      icon: '👁️',
      title: '24/7 Monitoring',
      description: 'Continuous security surveillance'
    },
    {
      icon: '🤖',
      title: 'AI Verification',
      description: 'Advanced fraud detection systems'
    },
    {
      icon: '🏢',
      title: 'Secure Infrastructure',
      description: 'Enterprise-grade security architecture'
    },
    {
      icon: '📋',
      title: 'Regulatory Compliance',
      description: 'Full compliance with RBI and other regulations'
    }
  ];

  const certifications = [
    'ISO 27001:2013',
    'PCI DSS Level 1',
    'RBI Compliant',
    'SOC 2 Type II'
  ];

  return (
    <div className={styles.container}>
      {/* Header */}
      <div className={styles.header}>
        <h1 className={styles.title}>Security</h1>
        <p className={styles.subtitle}>Protecting your data with enterprise-grade security measures</p>
      </div>

      {/* Main Content */}
      <div className={styles.content}>
        {/* Security Features */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Security Features</h2>
          <div className={styles.featuresGrid}>
            {securityFeatures.map((feature, index) => (
              <div key={index} className={styles.featureCard}>
                <div className={styles.featureIcon}>{feature.icon}</div>
                <h3 className={styles.featureTitle}>{feature.title}</h3>
                <p className={styles.featureDescription}>{feature.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Certifications */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Certifications</h2>
          <div className={styles.certifications}>
            {certifications.map((cert, index) => (
              <div key={index} className={styles.certification}>
                {cert}
              </div>
            ))}
          </div>
        </section>

        {/* Data Protection */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Data Protection</h2>
          <div className={styles.protectionGrid}>
            <div className={styles.protectionItem}>
              <h3>Encryption</h3>
              <ul>
                <li>AES-256 encryption at rest</li>
                <li>TLS 1.3 for data in transit</li>
                <li>End-to-end encryption</li>
              </ul>
            </div>
            <div className={styles.protectionItem}>
              <h3>Access Control</h3>
              <ul>
                <li>Multi-factor authentication</li>
                <li>Role-based permissions</li>
                <li>Session management</li>
              </ul>
            </div>
            <div className={styles.protectionItem}>
              <h3>Monitoring</h3>
              <ul>
                <li>24/7 security monitoring</li>
                <li>Real-time threat detection</li>
                <li>Regular security audits</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Compliance */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Compliance</h2>
          <div className={styles.compliance}>
            <div className={styles.complianceItem}>
              <h3>Reserve Bank of India</h3>
              <p>Full compliance with RBI guidelines for P2P lending platforms</p>
            </div>
            <div className={styles.complianceItem}>
              <h3>Data Protection</h3>
              <p>Adherence to Indian IT Act and data protection regulations</p>
            </div>
            <div className={styles.complianceItem}>
              <h3>International Standards</h3>
              <p>Following ISO and PCI DSS security standards</p>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className={styles.contactSection}>
          <h2 className={styles.sectionTitle}>Security Contact</h2>
          <div className={styles.contactInfo}>
            <p className={styles.contactEmail}>security@rupayya.com</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Security;